import loadable from '@loadable/component'
import {RouteConfig} from 'react-router-config'

export default [
  {
    path: '/svip',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-svip-home" */ '~/pages/Svip/pages/home'
        )
    ),
  },
  {
    path: '/svip/rule',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-svip-rule" */ '~/pages/Svip/pages/rule'
        )
    ),
  },
] as RouteConfig[]
